import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SelectionModel } from "@angular/cdk/collections";
import { FlatTreeControl } from "@angular/cdk/tree";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
  MatTreeModule,
} from "@angular/material/tree";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import swal from "sweetalert2";
import { PerfilService } from "../perfil.service";
import { Perfil } from "src/app/shared/model/security/perfil.model";
import { Menu } from "src/app/shared/model/security/menu.model";
import { arbolDelEditor } from "../arbol-del-editor";

export class TodoItemFlatNode {
  id!: number;
  id_Padre!: number;
  nombre!: string;
  level!: number;
  expandable!: boolean;
}

@Component({
  selector: "app-modificaperfil",
  standalone: true,
  templateUrl: "./modificaperfil.component.html",
  imports: [
    FormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatTreeModule,
  ],
})
export class ModificaperfilComponent implements OnInit {
  flatNodeMap = new Map<TodoItemFlatNode, Menu>();
  nestedNodeMap = new Map<Menu, TodoItemFlatNode>();
  selectedParent: TodoItemFlatNode | null = null;
  treeControl: FlatTreeControl<TodoItemFlatNode>;
  treeFlattener: MatTreeFlattener<Menu, TodoItemFlatNode>;
  dataSource: MatTreeFlatDataSource<Menu, TodoItemFlatNode>;
  checklistSelection = new SelectionModel<TodoItemFlatNode>(true);
  getLevel = (node: TodoItemFlatNode) => node.level;
  isExpandable = (node: TodoItemFlatNode) => node.expandable;
  getChildren = (node: Menu): Menu[] => node.hijos ?? [];
  hasChild = (_: number, nodeData: TodoItemFlatNode) => nodeData.expandable;
  transformer = (node: Menu, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.nombre === node.nombre
        ? existingNode
        : new TodoItemFlatNode();
    flatNode.nombre = node.nombre;
    flatNode.id = node.id;
    flatNode.id_Padre = node.id_Padre;
    flatNode.level = level;
    flatNode.expandable = !!node.hijos?.length;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };

  idperfil = 0;
  selectedValue = "";
  nombre = "";
  nombremodif: Perfil[] = [];
  sitioperfil: any[] = [];
  verSeleccion = "";
  listaModulo: Menu[] = [];
  milista: Menu[] = [];
  idsitio = "";
  beanPerfil = new Perfil();
  numero = 0;
  loadingMenus = false;

  constructor(
    private router: Router,
    private perfil: PerfilService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren
    );
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(
      this.getLevel,
      this.isExpandable
    );
    this.dataSource = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );
    this.dataSource.data = [];
  }

  ngOnInit() {
    this.idperfil = Number(
      this.route.snapshot.paramMap.get("id") ??
        this.route.snapshot.paramMap.get("pId")
    );

    if (!this.idperfil) {
      this.back();
      return;
    }

    this.ngConsultaSitios();
    this.loadPerfil();
  }

  get selectedMenusCount(): number {
    return this.checklistSelection.selected.length;
  }

  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return descendants.every((child) => this.checklistSelection.isSelected(child));
  }

  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some((child) =>
      this.checklistSelection.isSelected(child)
    );
    return result && !this.descendantsAllSelected(node);
  }

  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);
    this.checkAllParentsSelection(node);
  }

  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descendantsAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child)
    );
    if (nodeSelected && !descendantsAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descendantsAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let index = startIndex; index >= 0; index--) {
      const currentNode = this.treeControl.dataNodes[index];
      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  loadPerfil() {
    const perfilRequest = new Perfil();
    perfilRequest.id = this.idperfil;

    this.perfil.ConsulXUpdatePerfil(perfilRequest).subscribe({
      next: (res) => {
        this.nombremodif = res?.list ?? [];
        const perfil = this.nombremodif[0];
        if (!perfil) {
          this.back();
          return;
        }
        this.nombre = perfil.nombre;
        this.selectedValue = perfil.sitio;
        this.idsitio = perfil.sitio;
        this.numero = Number(perfil.id);
        this.cdr.detectChanges();
        this.ngConsultaMenus(this.idsitio, true);
      },
      error: () => this.back(),
    });
  }

  ngConsultaMenus(nombre: string, restoreSelection = false) {
    if (!nombre) {
      this.listaModulo = [];
      this.dataSource.data = [];
      this.checklistSelection.clear();
      return;
    }

    this.loadingMenus = true;
    this.checklistSelection.clear();
    // El arbol del sitio del perfil y el de Base: el servidor reemplaza
    // exactamente esos dos al guardar (ver arbol-del-editor.ts).
    arbolDelEditor(this.perfil, nombre).subscribe({
      next: (res) => {
        this.listaModulo = Array.isArray(res) ? res : [];
        this.dataSource.data = this.listaModulo;
        this.treeControl.collapseAll();
        this.cdr.detectChanges();

        if (!restoreSelection) {
          this.milista = [];
          this.loadingMenus = false;
          this.cdr.detectChanges();
          return;
        }

        this.perfil.ConsulXUpdateMenu(this.idperfil).subscribe({
          next: (menuRes) => {
            this.milista = menuRes?.list ?? [];
            this.inicializarHijos();
            this.loadingMenus = false;
            this.cdr.detectChanges();
          },
          error: () => {
            this.milista = [];
            this.loadingMenus = false;
            this.cdr.detectChanges();
          },
        });
      },
      error: () => {
        this.listaModulo = [];
        this.dataSource.data = [];
        this.loadingMenus = false;
        this.cdr.detectChanges();
      },
    });
  }

  inicializarHijos() {
    this.checklistSelection.clear();
    const nodes = this.treeControl.dataNodes;
    nodes.forEach((node) => {
      if (this.milista.some((item) => item.id === node.id)) {
        this.checklistSelection.select(node);
      }
    });
    this.cdr.detectChanges();
  }

  capturar(nombre: string) {
    this.verSeleccion = this.selectedValue;
    this.milista = [];
    this.ngConsultaMenus(nombre, false);
  }

  ngConsultaSitios() {
    this.perfil.ConsultaSitios().subscribe((res) => {
      this.sitioperfil = Array.isArray(res) ? res : [];
      this.cdr.detectChanges();
    });
  }

  Modificar() {
    this.milista = this.checklistSelection.selected.map((node) => ({
      factory: "",
      id: node.id,
      id_Padre: node.id_Padre,
      icono: "",
      nombre: node.nombre,
      tipo: "",
    }));

    this.beanPerfil.nombre = this.nombre?.trim();
    this.beanPerfil.sitio = this.selectedValue;
    this.beanPerfil.menus = this.milista;
    this.beanPerfil.id = this.numero;

    if (!this.beanPerfil.nombre || !this.beanPerfil.sitio) {
      swal.fire({
        title: "Ops!",
        text: "Faltan campos por llenar",
        icon: "error",
        confirmButtonColor: "danger",
        showConfirmButton: true,
      });
      return;
    }

    this.perfil.GuardaPerfil(this.beanPerfil).subscribe({
      next: () => {
        this.perfil.setPerfilesCache(null);
        swal
          .fire({
            title: "Se modificó correctamente",
            timer: 5000,
            icon: "success",
            showConfirmButton: true,
          })
          .then(() => this.back());
      },
      error: (e) => {
        swal.fire({
          title: "No fue posible actualizar el perfil",
          text: e instanceof Error && e.message ? e.message : "Intenta nuevamente en unos momentos.",
          icon: "error",
          showConfirmButton: true,
        });
      },
    });
  }

  back(): void {
    this.router.navigate(["/admin/perfil"]);
  }
}
